import bigHole from "../assets/Fallback/Big Hole/bigHole04.jpg";
import mineMuseum from "../assets/Fallback/Kimberley Mine Museum/mineMuseum06.jpg";
import kamfersDam from "../assets/KamferDam.jpg";
import williamGallery from "../assets/william.jpg";

export const createPlaceSlug = (name) =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const placesToVisit = [
  {
    name: "The Big Hole",
    description:
      "The Big Hole is a massive man-made excavation and one of the deepest holes in the world. It's a must-visit for history and diamond enthusiasts.",
    image: bigHole,
    category: "Heritage Landmark",
    location: "Kimberley, Northern Cape",
    bestFor: ["History", "Photography", "Family Visits"],
    highlights: [
      "One of Kimberley's most recognisable heritage landmarks.",
      "A strong introduction to the city's diamond-mining story.",
      "Good for visitors who want a mix of views, museums, and local history.",
    ],
    content: [
      "The Big Hole is the landmark many visitors associate with Kimberley first. It tells the story of diamond mining, ambition, labour, and the growth of the Diamond City in a way that is easy to understand even on a short visit.",
      "The experience is strongest when you give yourself time to take in the viewpoint and the surrounding heritage atmosphere. It is not just a photo stop; it is a place that helps explain why Kimberley became important.",
      "Pair it with a nearby restaurant, museum stop, or relaxed walk through the surrounding historic area to make the outing feel complete.",
    ],
    visitorNotes: "Best visited during the day for clear views and easier photography.",
  },
  {
    name: "Kimberley Mine Museum",
    description:
      "Step back in time and explore the history of diamond mining in Kimberley. The museum offers a glimpse into the life of miners in the 19th century.",
    image: williamGallery,
    category: "Museum",
    location: "Kimberley, Northern Cape",
    bestFor: ["Museums", "Heritage", "Learning"],
    highlights: [
      "A good companion stop to the Big Hole.",
      "Helps visitors understand mining life and Kimberley's early growth.",
      "Useful for school groups, families, and history-focused travellers.",
    ],
    content: [
      "The Kimberley Mine Museum adds context to the city by focusing on the people, places, and everyday details around the diamond-mining era.",
      "Visitors can use it as a slower, more educational stop after seeing the Big Hole. It gives the wider story more texture, especially for people who enjoy heritage spaces and old-town atmosphere.",
      "It works well as part of a half-day Kimberley history route, especially when combined with nearby attractions.",
    ],
    visitorNotes: "Allow enough time to read displays and move through the heritage setting slowly.",
  },
  {
    name: "Kamfers Dam",
    description:
      "A haven for bird watchers, Kamfers Dam is home to thousands of flamingos. It's a perfect spot for nature lovers and photographers.",
    image: kamfersDam,
    category: "Nature Experience",
    location: "Kimberley, Northern Cape",
    bestFor: ["Bird Watching", "Nature", "Photography"],
    highlights: [
      "Known for flamingos and peaceful water views.",
      "A quieter nature-focused contrast to the city's heritage stops.",
      "Best for visitors who enjoy slow scenic moments.",
    ],
    content: [
      "Kamfers Dam offers a calmer side of Kimberley. It is especially interesting for bird watchers and visitors who want a nature stop between museums, restaurants, and city attractions.",
      "The dam is closely associated with flamingos, which makes it memorable for photographers and nature lovers. The experience depends on season, weather, and access, so it is best approached as a scenic stop rather than a highly structured attraction.",
      "It pairs well with a relaxed morning or late-afternoon itinerary when the light is softer.",
    ],
    visitorNotes: "Bring a camera or binoculars if bird watching is part of your plan.",
  },
  {
    name: "William Humphreys Art Gallery",
    description:
      "This art gallery houses an impressive collection of South African and European art. A cultural gem in the heart of Kimberley.",
    image: mineMuseum,
    category: "Arts & Culture",
    location: "Kimberley, Northern Cape",
    bestFor: ["Art", "Culture", "Quiet Visits"],
    highlights: [
      "A strong culture stop in central Kimberley.",
      "Good for visitors who want a break from outdoor sightseeing.",
      "Adds an artistic layer to the city's heritage story.",
    ],
    content: [
      "The William Humphreys Art Gallery gives visitors a quieter, more reflective Kimberley experience. It is a good stop for people interested in art, culture, and the city's civic spaces.",
      "The gallery helps round out a Kimberley itinerary by adding something different from mining history and nature routes. It is especially useful on hot days or when visitors want an indoor cultural experience.",
      "Pair it with a cafe or another nearby city stop for an easy, low-pressure outing.",
    ],
    visitorNotes: "Check opening times before visiting, especially around weekends and public holidays.",
  },
].map((place) => ({
  ...place,
  slug: createPlaceSlug(place.name),
}));
